module.exports = __webpack_public_path__ + "images/ds-mwe-banner-side.webp";